import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import {
  CurrencyService,
  getContextParameterDefault,
  LanguageService,
  OccEndpointsService,
  SiteContextConfig,
  SiteContextInterceptor
} from '@spartacus/core';
import { Observable } from 'rxjs';

import { MEASUREMENT_SYSTEM_CONTEXT_ID } from '@app-modules/site-context/constants/measurement-system-context-id.constant';
import { DpMeasurementSystemService } from '@app-modules/site-context/facade/measurement-system.service';

@Injectable({ providedIn: 'root' })
export class DpSiteContextInterceptor extends SiteContextInterceptor {
  activeLang: string | undefined;
  activeCurr: string | undefined;
  activeMeasurementSystem: string | undefined;

  readonly #measurementSystemService = inject(DpMeasurementSystemService);

  constructor(
    private readonly occEndpointsService: OccEndpointsService,
    languageService: LanguageService,
    currencyService: CurrencyService,
    config: SiteContextConfig
  ) {
    super(languageService, currencyService, occEndpointsService, config);
    this.activeMeasurementSystem = getContextParameterDefault(config, MEASUREMENT_SYSTEM_CONTEXT_ID);
    this.#measurementSystemService.getActive().subscribe((data) => (this.activeMeasurementSystem = data));
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes(this.occEndpointsService.getBaseUrl())) {
      request = request.clone({
        setParams: {
          lang: this.activeLang ?? '',
          curr: this.activeCurr ?? '',
          measurementSystem: this.activeMeasurementSystem ?? ''
        }
      });
    }

    return next.handle(request);
  }
}
